<tt-page *ngIf="!!menu">
    <tt-card class="col-xs-12 sp-0" *ngIf="'tablet' | mediaQuery">
        <ng-container *ngTemplateOutlet="info"></ng-container>
        <ng-container *ngTemplateOutlet="buttons"></ng-container>
    </tt-card>

    <div class="col-xs-12 sp-0" *ngIf="! ('tablet' | mediaQuery)">
        <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="h_info">
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="h_functions">
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!menu">
        <tt-input ttLabel="travelwage_id" [ttModel]="menu.travelwage_id" ttReadonly></tt-input>
        <tt-input ttLabel="travelwage_name" [ttModel]="menu.travelwage_name" ttReadonly></tt-input>
        <pre *ngIf="menu.glyphicon.slice(0, 3) === 'fa-'"><span class="fa {{menu.glyphicon}}" style="font-size:40px;"></span></pre>
        <pre *ngIf="menu.glyphicon.slice(0, 4) === 'fab-'"><span class="fab fa-{{menu.glyphicon.slice(4, menu.glyphicon.length)}}" style="font-size:40px;"></span></pre>
        <pre *ngIf="menu.glyphicon.slice(0, 4) === 'fad-'"><span class="far fa-{{menu.glyphicon.slice(4, menu.glyphicon.length)}}" style="font-size:40px;"></span></pre>
        <pre *ngIf="menu.glyphicon.slice(0, 4) === 'far-'"><span class="far fa-{{menu.glyphicon.slice(4, menu.glyphicon.length)}}" style="font-size:40px;"></span></pre>
        <pre *ngIf="menu.glyphicon.slice(0, 4) === 'fas-'"><span class="fas fa-{{menu.glyphicon.slice(4, menu.glyphicon.length)}}" style="font-size:40px;"></span></pre>
        <pre *ngIf="menu.glyphicon.slice(0, 10) === 'glyphicon-'"><span class="glyphicon {{menu.glyphicon}}" style="font-size:40px;"></span></pre>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!menu">
        <tt-button-goto ttText="travelwagemenu_edit" ttGoto="travelwage" [ttGotoParms]="{ travelwage_id: menu.travelwage_id }"></tt-button-goto>
        <tt-button-goto ttText="travelwagemenu_checklistitemtws" ttGoto="checklistitemtws" [ttGotoParms]="{argtype: 'travelwage_id', argvalue: menu.travelwage_id}"></tt-button-goto>
        <tt-button ttText="travelwagemenu_delete" [ttLoading]="deleting" (ttClick)="deleteValues()" ttType="danger" ttIcon="fas fa-trash-alt"></tt-button>
    </ng-container>
</ng-template>